import { render, staticRenderFns } from "./BemVindo.vue?vue&type=template&id=4404c2df"
import script from "./BemVindo.vue?vue&type=script&lang=js"
export * from "./BemVindo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports